









































import {defineComponent} from "@vue/composition-api"

export default defineComponent({
  props: {title: {required: true, type: String}},
  setup(p, c) {

  },
})
